var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "shippingCostModal",
      attrs: { id: "shippingscosts-modal-wrapper" },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "shippingscosts",
            role: "dialog",
            "aria-modal": "true",
            tabindex: "-1",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "buttonScroller" }, [
                  _c(
                    "div",
                    {
                      class:
                        "buttonHolder loc_" + _vm.localization.localeClient,
                    },
                    _vm._l(_vm.regions, function (region, index) {
                      return _c(
                        "button",
                        {
                          key: index,
                          class: [
                            "btn",
                            "btn-bkm-white",
                            region.class,
                            { active: _vm.activeRegion === index },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.setActiveRegion(index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(region.label) +
                              "\n                            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "contentHolder",
                    class: { loading: _vm.isLoading },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "table" },
                      _vm._l(_vm.shippingServices, function (service) {
                        return _c(
                          "div",
                          {
                            staticClass: "line",
                            class: {
                              active: _vm.shippingProvider == service.type,
                            },
                          },
                          [
                            _c("span", { staticClass: "nameLogo" }, [
                              service.gogreen
                                ? _c("img", {
                                    staticClass: "gogreen",
                                    attrs: {
                                      alt: "DHL GoGreen",
                                      src: "https://cdn.bio-kinder.de/frontend/resources/img/footer/gogreen.svg",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              service.co2neutral
                                ? _c("img", {
                                    staticClass: "gogreen",
                                    attrs: {
                                      alt: "CO2-neutraler Versand",
                                      src: "https://cdn.bio-kinder.de/frontend/resources/img/footer/co2neutral-paket.svg",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "serviceName" }, [
                                _vm._v(_vm._s(service.name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "prices" }, [
                              _c("span", { staticClass: "cost" }, [
                                _vm._v(_vm._s(service.cost)),
                              ]),
                              _vm._v(" "),
                              _vm.additionalInfo != ""
                                ? _c("span", {
                                    staticClass: "additionalInfo",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.additionalInfo),
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            service.details
                              ? _c(
                                  "ul",
                                  { staticClass: "optionalDetails" },
                                  _vm._l(service.details, function (detail) {
                                    return _c("li", {
                                      domProps: { innerHTML: _vm._s(detail) },
                                    })
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fair" }, [
                      _c("span", {
                        staticClass: "headline",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "biokinderDesign::Template.shippingModalFairShipping"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "biokinderDesign::Template.shippingModalFairDescription"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "biokinderDesign::Template.shippingModalDetails"
                            )
                          ),
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title h3" }, [_vm._v("Versandkosten")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true",
          },
        },
        [_vm._v("×")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }